/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Opening_ChatInputs */

const en_opening_chat = /** @type {(inputs: Opening_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening chat...`)
};

const es_opening_chat = /** @type {(inputs: Opening_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abriendo chat...`)
};

const fr_opening_chat = /** @type {(inputs: Opening_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouverture du chat...`)
};

const de_opening_chat = /** @type {(inputs: Opening_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat wird geöffnet...`)
};

const id_opening_chat = /** @type {(inputs: Opening_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membuka obrolan...`)
};

/** @type {(inputs: Opening_ChatInputs) => LocalizedString} */
const ja_opening_chat = en_opening_chat;

/** @type {(inputs: Opening_ChatInputs) => LocalizedString} */
const zh_opening_chat = en_opening_chat;

/** @type {(inputs: Opening_ChatInputs) => LocalizedString} */
const ar_opening_chat = en_opening_chat;

/** @type {(inputs: Opening_ChatInputs) => LocalizedString} */
const it_opening_chat = en_opening_chat;

/** @type {(inputs: Opening_ChatInputs) => LocalizedString} */
const ru_opening_chat = en_opening_chat;

/** @type {(inputs: Opening_ChatInputs) => LocalizedString} */
const pt_opening_chat = en_opening_chat;

/** @type {(inputs: Opening_ChatInputs) => LocalizedString} */
const ko_opening_chat = en_opening_chat;

/**
* | output |
* | --- |
* | "Opening chat..." |
*
* @param {Opening_ChatInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const opening_chat = /** @type {((inputs?: Opening_ChatInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Opening_ChatInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_opening_chat(inputs)
	if (locale === "es") return es_opening_chat(inputs)
	if (locale === "fr") return fr_opening_chat(inputs)
	if (locale === "de") return de_opening_chat(inputs)
	if (locale === "ja") return ja_opening_chat(inputs)
	if (locale === "zh") return zh_opening_chat(inputs)
	if (locale === "ar") return ar_opening_chat(inputs)
	if (locale === "id") return id_opening_chat(inputs)
	if (locale === "it") return it_opening_chat(inputs)
	if (locale === "ru") return ru_opening_chat(inputs)
	if (locale === "pt") return pt_opening_chat(inputs)
	return ko_opening_chat(inputs)
});